const record = value => value !== null && typeof value === "object" && !Array.isArray(value);
const booleanFields = ["veterinary", "technical", "welfareReferent", "canPushToZims"];
// Champ du formulaire → clé de `users/{uid}.rights`.
const RIGHT_KEYS = { veterinary: "vet", technical: "technical", welfareReferent: "bea" };

/** Only the user's edits belong to this command, not the whole stale form. */
export const individualPermissionChanges = (before = {}, after = {}) => {
  const changes = {};
  for (const key of booleanFields) {
    if (Object.prototype.hasOwnProperty.call(after, key) && (before[key] === true) !== (after[key] === true)) {
      changes[key] = after[key] === true;
    }
  }
  if (record(after.vetData)) {
    const vetData = Object.fromEntries(Object.entries(after.vetData).filter(([key, value]) =>
      JSON.stringify(value) !== JSON.stringify(before.vetData?.[key])));
    if (Object.keys(vetData).length) changes.vetData = vetData;
  }
  return changes;
};

/** Merge the explicit changes into the current server representation. */
export const applyIndividualPermissionChanges = (current, changes) => {
  const patch = {};
  const selectedRights = current.rights || current.userRights;
  const rights = record(selectedRights) ? { ...selectedRights } : {};
  let rightsChanged = false;
  for (const key of Object.keys(RIGHT_KEYS)) {
    if (!Object.prototype.hasOwnProperty.call(changes, key)) continue;
    rights[RIGHT_KEYS[key]] = changes[key] === true;
    if (key === "veterinary") delete rights.veterinary;
    rightsChanged = true;
  }
  // Le résumé hebdomadaire ne suit pas les droits : chacun coche sa case
  // (décision du 29/10/2026, plus d'abonnement d'office).
  if (record(changes.vetData) && Object.keys(changes.vetData).length) {
    rights.vetData = { ...(record(rights.vetData) ? rights.vetData : {}), ...changes.vetData };
    rightsChanged = true;
  }
  if (rightsChanged) patch.rights = rights;
  if (Object.prototype.hasOwnProperty.call(changes, "canPushToZims")) patch.canPushToZims = changes.canPushToZims === true;
  return patch;
};

export const updateIndividualPermissions = async ({ db, userId, zooId, changes, stamp = {} }) => {
  if (typeof userId !== "string" || !userId || userId.includes("/")) throw new Error("INVALID_USER_ID");
  if (!Object.keys(changes).length) return;
  const ref = db.collection("users").doc(userId);
  await db.runTransaction(async transaction => {
    const snapshot = await transaction.get(ref);
    if (!snapshot.exists) throw new Error("ACCOUNT_NOT_FOUND");
    const current = snapshot.data();
    if (current.zooId !== zooId) throw new Error("PROFILE_ZOO_CHANGED");
    const patch = applyIndividualPermissionChanges(current, changes);
    if (Object.keys(patch).length) transaction.update(ref, { ...patch, ...stamp });
  });
};
